import React from 'react';
import { THEME_OPTIONS, DEFAULT_THEME_NAME } from './constants';

const defaultTheme = THEME_OPTIONS[DEFAULT_THEME_NAME];
const ThemeContext = React.createContext(defaultTheme);

export default ThemeContext;
